import script from "./Yoube.vue?vue&type=script&setup=true&lang=js"
export * from "./Yoube.vue?vue&type=script&setup=true&lang=js"

import "./Yoube.vue?vue&type=style&index=0&id=a5c46594&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c46594"]])

export default __exports__